<template>
  <div>
    <div
      style="padding: 80px 0px; background-color: #f8f6f2; position: relative"
    >
      <v-main>
        <v-container>
          <h2 class="section-name">Unsere Dienstleistungen</h2>
          <v-row
            no-gutters
            :style="
              $vuetify.breakpoint.smAndDown
                ? 'margin: 34px 0px;'
                : 'margin: 64px 0px'
            "
          >
            <v-col
              cols="12"
              xl="6"
              lg="6"
              md="6"
              sm="12"
              v-for="(service, index) in servicesList"
              :key="service.id"
              :style="
                $vuetify.breakpoint.smAndDown
                  ? 'margin-bottom: 0px;'
                  : (index + 1) % 2 === 0
                  ? 'padding-left: 16px'
                  : 'padding-right: 16px'
              "
            >
              <div class="service-card">
                <img
                  :src="service.photo"
                  width="100%"
                  height="192px"
                  style="object-fit: cover"
                />
                <div style="padding: 32px">
                  <h3 class="service-title">{{ service.service_name_de }}</h3>
                  <ul class="service-description">
                    <li v-for="point in service.text_points" :key="point.id">
                      {{ point.text }}
                    </li>
                  </ul>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
      <img
        src="@/assets/img/Backgrounds/ourServiceBackgroundBottom.svg"
        width="100%"
        height="auto"
        alt="background"
        style="position: absolute; z-index: 100; bottom: 0; left: 0"
      />
    </div>
  </div>
</template>

<script>
import servicesService from "../../requests/Admin/servicesService";

export default {
  data: () => ({
    servicesList: [],
  }),
  mounted() {
    this.getServices();
  },
  methods: {
    async getServices() {
      await servicesService
        .getServices()
        .then((res) => (this.servicesList = res));
    },
  },
};
</script>

<style scoped>
.service-card {
  margin-bottom: 32px;
  border-radius: 8px;
  border: 1px solid #e9e4d8;
  background: #fff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
.service-title {
  color: #163626;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
.service-description {
  color: #163626;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  margin-top: 24px;
}
.service-description li {
  margin-bottom: 12.2px;
}
.service-description li::marker {
  color: #c09559;
  font-size: 18px;
}
</style>